module.exports = __webpack_public_path__ + "img/displacementHor-back.99f79f1f.svg";